import api from './../../../shared/functions/api/';
import { permalink } from './../strings';

export const fetchBlogPosts = async (status='all') => {
  const res = await api.get(`/posts/${status}`);

  const blogPosts = res.data.map(blogPost => {
    let title = blogPost.title;
    blogPost.id = blogPost._id;
    blogPost.url = `/news/post/${permalink(title)}`;
    blogPost.params = `?id=${blogPost.id}`;
    return blogPost;
  });

  return blogPosts;
};